// Types shared across multiple core components

export enum FieldTypes {
  text = 'text',
  number = 'number',
  range = 'range',
  email = 'email',
  password = 'password',
  date = 'date',
  search = 'search',
  radio = 'radio',
  checkbox = 'checkbox',
  switch = 'switch',
  textarea = 'textarea',
  select = 'select',
}
